import {Action} from "redux";
import {IClientMessageRoomActionCreator} from "../action/client_message_room_action";
import {
    CreateMessageRoomByClientRequest,
    SendMessageByClientRequest
} from "../request/message_room_request";

interface IClientMessageRoomDispatcher {

    createMessageRoom(item: CreateMessageRoomByClientRequest): void;

    sendMessageRoom(item: SendMessageByClientRequest): void;

    destroyMessageRoom(): void;
}

class Dispatcher implements IClientMessageRoomDispatcher {

    constructor(private dispatch: (action: Action) => void,
                private actionCreator: IClientMessageRoomActionCreator) {

    }

    public createMessageRoom = (item: CreateMessageRoomByClientRequest): void => {
        this.dispatch(this.actionCreator.requestCreateMessageRoomAction(item));
    };

    public sendMessageRoom = (item: SendMessageByClientRequest): void => {
        this.dispatch(this.actionCreator.requestSendMessageRoomAction(item));
    };

    public destroyMessageRoom = (): void => {
        this.dispatch(this.actionCreator.requestDestroyMessageRoomAction());
    }

}

const createClientMessageRoomDispatcher = (dispatch: (action: Action) => void, actionCreator: IClientMessageRoomActionCreator): IClientMessageRoomDispatcher => {
    return new Dispatcher(dispatch, actionCreator);
};

export {IClientMessageRoomDispatcher, createClientMessageRoomDispatcher};



// WEBPACK FOOTER //
// ./src/presentation/dispatcher/client_message_room_dispatcher.ts